export const useIsFromFlipkartUrl = () => {
  return window.location.href.includes('flipkart') == true
  // return false
};

export const useIsFromFlipkartEnv = () => {
  return process.env?.REACT_APP_CUSTOM_APP_SOURCE === 'flipkart' == true;
  // return false
};